import NextLink from 'next/link';
import PropTypes from 'prop-types';

import Button from 'shopper/components/Button';

import placeholder from 'lib/placeholder';

import Store from './Store';

import LINKS from 'constants/links';

const Stores = ({ showStoreImages = false, stores, onClose }) => (
  <div className="mb-4 grid grid-cols-4 gap-4 px-6">
    {stores.map((store) => (
      <Store
        key={store.pageTitle}
        showStoreImage={showStoreImages}
        onClick={onClose}
        {...store}
      />
    ))}
    <NextLink href={LINKS.STORES} prefetch={false} passHref>
      <Button
        as="a"
        className="self-center"
        size="size4"
        type="primary"
        onClick={onClose}
      >
        {placeholder('actions.seeAllStores')}
      </Button>
    </NextLink>
  </div>
);

Stores.propTypes = {
  showStoreImages: PropTypes.bool,
  stores: PropTypes.arrayOf(
    PropTypes.shape({
      backgroundPageLink: PropTypes.string,
      pageFrom: PropTypes.string.isRequired,
      pageImage: PropTypes.string.isRequired,
      pageLink: PropTypes.string,
      pageParam: PropTypes.string.isRequired,
      pageTitle: PropTypes.string.isRequired,
      showStoreImage: PropTypes.bool,
    })
  ).isRequired,
  onClose: PropTypes.func.isRequired,
};

export default Stores;
